export const HEIGHT_SELECT_INPUT = 40;
export const MAX_HEIGHT_SELECT_POPOVER = 350;
export const DEFAULT_MESSAGE_EMPTY_LIST = 'Нет доступных совпадений';